export const defaultParamsSerializer = (params: Record<string, any>) => {
  const queryString = new URLSearchParams();

  for (const key in params) {
    const value = params[key];
    if (Array.isArray(value)) {
      value.forEach(v => v !== undefined && queryString.append(key, v));
    } else if (value !== undefined) {
      queryString.append(key, value);
    }
  }

  return queryString.toString();
};
